import { useState, useEffect } from 'react';
import useDomain from '../../../pages/domains/useDomain';
import useTraffic from '../../../pages/traffic/useTraffic';
import useCampaign from '../../../pages/campaigns/useCampaign';
import useCustomOffer from '../../../pages/offerGroup/useCustomOffers';

export function useWizardData() {
  const [domains, setDomains] = useState<any[]>([]);
  const [trafficSources, setTrafficSources] = useState<any[]>([]);
  const [campaigns, setCampaigns] = useState<any[]>([]);
  const [offerGroups, setOfferGroups] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const { getDomains } = useDomain();
  const { getTraffic } = useTraffic();
  const { getCampaigns } = useCampaign();
  const { getOfferGroups } = useCustomOffer();

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const domainsCall = getDomains();
      const trafficCall = getTraffic();
      const campaignsCall = getCampaigns();
      const offerGroupsCall = getOfferGroups();

      const [domainsData, trafficData, campaignsData, offerGroupsData] =
        await Promise.all([
          domainsCall.call(),
          trafficCall.call(),
          campaignsCall.call(),
          offerGroupsCall.call(),
        ]);

      setDomains(domainsData || []);
      setTrafficSources(trafficData || []);
      setCampaigns(campaignsData || []);
      setOfferGroups(offerGroupsData || []);
    } catch (err) {
      setError('Failed to load wizard data');
      console.error('Error fetching wizard data:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const entryDomains = domains.filter(domain => domain.isEntry === true && domain.active);
  const redirectDomains = domains.filter(domain => !domain.isEntry && domain.active);

  return {
    domains,
    trafficSources,
    campaigns,
    offerGroups,
    entryDomains,
    redirectDomains,
    loading,
    error,
  };
}
